<template>
    <div class="widget-talk-to-expert" :class="[style]">
        <div class="icon">
            <SvgsExpert />
        </div>
        <div class="info">
            <div class="info-label">Talk to an expert</div>
            <div class="info-link">
                <button class="link" title="Find a dealer nearby" @click="eventType">Find a dealer nearby</button>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        style: {
            type: String,
            default: "default"
        },
        type: {
            type: String,
            default: "open-widget"
        }
    });

    const globalStore = useGlobalStore();
    const { $gsap: gsap } = useNuxtApp();

    const eventType = async () => {
        if (props.type == "open-widget") {
            globalStore.setSearchDealer(true);
        }

        if (props.type == "scroll-to") {
            const findADealer = document.getElementById(`c-find-dealer`);

            if (findADealer) {
                gsap.to(window, {
                    duration: 1.25,
                    delay: 0,
                    ease: "linear",
                    scrollTo: {
                        y: findADealer,
                        offsetY: 50
                    }
                });
            }
        }
    };
</script>
